import { api } from './api.js';

/**
 * File access for the scene/model document stores.
 *
 * Goes through the existing project file API. Swappable so the stores can be
 * tested without a server.
 */
export interface DocIO {
  read(projectId: number, path: string): Promise<string>;
  write(projectId: number, path: string, content: string): Promise<void>;
}

const httpIO: DocIO = {
  async read(projectId, path) {
    const result = await api.get<{ file: { content: string } }>(
      `/projects/${projectId}/file?path=${encodeURIComponent(path)}`,
    );
    return result.file.content;
  },
  async write(projectId, path, content) {
    await api.put(`/projects/${projectId}/file`, { path, content });
  },
};

let current: DocIO = httpIO;

export function docIO(): DocIO {
  return current;
}

/** Replace the IO (tests). Pass null to restore HTTP. */
export function setDocIO(io: DocIO | null): void {
  current = io ?? httpIO;
}

/** Debounce delay for autosaving scene/model edits. */
export const SAVE_DELAY_MS = 400;
